import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Trending from "./components/Trending";
import Poll from "./components/Poll";
import Stage from "./components/Stage";
import Gossip from "./components/Gossip";
import Mentor from "./components/Mentor";
import Eliminate from "./components/Eliminate";
import Faq from "./components/Faq";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <Navbar />
      <main>
        <Hero />
        <Trending />
        <Poll />
        <Stage />
        <Gossip />
        <Mentor />
        <Eliminate />
        <Faq />
        <About />
        <Contact />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}

function BackToTop() {
  return (
    <a
      href="#top"
      aria-label="返回顶部"
      title="返回顶部"
      className="fixed bottom-6 right-6 z-50 flex h-11 w-11 cursor-pointer items-center justify-center rounded-full border border-background-300 bg-background-50 text-foreground-700 transition-colors hover:bg-primary-600 hover:text-background-50"
    >
      <i className="ri-arrow-up-line text-lg" aria-hidden="true" />
    </a>
  );
}